/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Step_FileInputs */



/**
* | output |
* | --- |
* | "Upload" |
*
* @param {Team_Manager_Import_Step_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_step_file = /** @type {((inputs?: Team_Manager_Import_Step_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Step_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei")
	if (locale === "it") return /** @type {LocalizedString} */ ("File")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Файл")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上传")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपलोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ficheiro")
	return /** @type {LocalizedString} */ ("Upload")
});